import { useCallback } from 'react';
import { FeatureFlags, useFeatureFlag } from '~/utils/featureflagsV2';
import {
  BlackbeardOrdersOptInOutValue,
  clearOptInOutSnooze,
  getBlackbeardOrdersStorageValue,
  getOptInOutDismissed,
  setBlackbeardOrdersStorageValue,
  shouldShowBlackbeardOrders,
  snoozedOptInPrompt as getSnoozedOptInPrompt,
  storeSnoozeValue,
} from './helpers';

// Comparison time provided as argument for easier testing
export function useBlackbeardOrdersVisibility(now = new Date()) {
  const ordersRedesign = useFeatureFlag(FeatureFlags.ORDERS_REDESIGN);
  const ordersRedesignWithOptInOptOut = useFeatureFlag(
    FeatureFlags.ORDERS_REDESIGN_WITH_OPT_IN_OPT_OUT,
  );

  const optInOutValue = getBlackbeardOrdersStorageValue();

  const showOrdersRedesign = shouldShowBlackbeardOrders(
    !!ordersRedesign?.enabled,
    ordersRedesignWithOptInOptOut?.variation
      ? ordersRedesignWithOptInOptOut.variation
      : 'initialOptIn',
    optInOutValue,
  );

  const onChangeOptInOut = useCallback((newValue: BlackbeardOrdersOptInOutValue) => {
    setBlackbeardOrdersStorageValue(newValue);
    clearOptInOutSnooze();
  }, []);

  const onSnoozeOptInOut = useCallback((optInOutType: BlackbeardOrdersOptInOutValue) => {
    storeSnoozeValue(optInOutType);
  }, []);

  // We can't memoize these because they rely on localStorage
  const dismissedOptOutPrompt = !!getOptInOutDismissed('optOut');
  const snoozedOptInPrompt = getSnoozedOptInPrompt('optIn', now);

  return {
    onChangeOptInOut,
    showOrdersRedesign,
    // Returns undefined so we can do simple truthiness checks
    initialOptInOptOutValue:
      ordersRedesignWithOptInOptOut?.variation === 'disabled'
        ? undefined
        : ordersRedesignWithOptInOptOut?.variation,
    optInOutValue,
    onSnoozeOptInOut,
    dismissedOptOutPrompt,
    snoozedOptInPrompt,
  };
}
